export default __webpack_public_path__ + "static/media/homework.2ce38deb.png";